export const nil = new Error('#NULL!')
export const div0 = new Error('#DIV/0!')
export const value = new Error('#VALUE!')
export const ref = new Error('#REF!')
export const name = new Error('#NAME?')
export const num = new Error('#NUM!')
export const na = new Error('#N/A')
export const error = new Error('#ERROR!')
export const data = new Error('#GETTING_DATA')
export const calc = new Error('#CALC!')
